<template>
  <div class="elevation-0 mb-3 error-top">
    <v-card-text v-for="terms in termsList" :key="terms.id">
      <w-checkbox :id="'term_' + terms.id" :label="termsLabel(terms)" :model="model['term_' + terms.id]" />

      <div class="terms" v-html="terms.content" />

      <a v-if="terms.mediaId" target="_blank" :href="mediaUrl(terms)">Pobierz</a>
    </v-card-text>
  </div>
</template>

<script>
import { WCheckbox } from '@witkac/vuetify-components';

import { config } from '@/utils/config';

// @vuese
// Input do zaznaczania udzielonych zgód
export default {
  components: { WCheckbox },
  props: {
    // model zgód
    model: {
      type: Object,
      required: true
    },
    // lista regulaminów
    termsList: {
      type: Array,
      required: true
    }
  },
  methods: {
    // @vuese
    // Zwraca adres do pobrania pliku
    mediaUrl(terms) {
      return `${config.mediaURL}/${terms.mediaId}`;
    },

    // @vuese
    // Zwraca label checkboxa regulaminu
    termsLabel(terms) {
      return `Akceptuję ${terms.name} ${terms.required ? '*' : ''}`;
    }
  }
};
</script>

<style>
.terms {
  margin-bottom: 5px;
  padding: 10px;
  background: rgb(231, 226, 226);
  max-height: 500px;
  overflow-y: auto;
}
</style>
